import React, { useState } from 'react';
import Collapse from 'react-bootstrap/Collapse';
import { Container, Row, Col, InputGroup, Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { handleError } from '@rd-web-markets/shared/dist/store/features/alertSlice';
import { claimProjectOverviewNoteService } from '@rd-web-markets/shared/dist/services/claim_project_overview/claim_project_overview_notes.service';
import { createTimezonedDate } from '@rd-web-markets/shared/dist/util/date/dateUtils';
import { Button, DeleteButton } from '@rd-web-markets/shared/dist/util/buttons';
import { useTranslation } from 'react-i18next';
import ImmutableUnderReviewFormControl from '../util/reviewEditControls/ImmutableUnderReviewFormControl';
const ClaimProjectNotes = _ref => {
  let {
    isImmutableUnderReview,
    report,
    setReport,
    pageAccess
  } = _ref;
  const user = useSelector(state => state.auth.user);
  const dispatch = useDispatch();
  const {
    t
  } = useTranslation();
  const [open, setOpen] = useState(true);
  const [comment, setComment] = useState('');
  const postComment = async () => {
    try {
      const response = await claimProjectOverviewNoteService.create(report.id, {
        note: comment
      });
      report.report_notes.push(response);
      setReport({
        ...report
      });
      setComment('');
    } catch (e) {
      dispatch(handleError(e));
    }
  };
  const deleteComment = async (noteId, note) => {
    if (window.confirm('Are you sure you wish to delete this comment? ' + note.substring(0, 20) + '...')) {
      try {
        await claimProjectOverviewNoteService.delete(report.id, noteId);
        const indexToRemove = report.report_notes.findIndex(note => note.id === noteId);
        report.report_notes.splice(indexToRemove, 1);
        setReport({
          ...report
        });
      } catch (e) {
        dispatch(handleError(e));
      }
    }
  };
  const extractDate = date => {
    return createTimezonedDate(date).toCustomLocaleDateString();
  };
  const renderComments = () => {
    return (report.report_notes || []).sort((a, b) => a.id && b.id - a.id).map((data, i) => {
      return i !== 0 && renderOneComment(data);
    });
  };
  const renderOneComment = data => {
    if (!data) return;
    return /*#__PURE__*/React.createElement(Row, {
      key: data.id,
      className: "mt-2"
    }, /*#__PURE__*/React.createElement(Col, {
      md: "8"
    }, /*#__PURE__*/React.createElement("div", {
      className: "bg-secondary"
    }, data.note)), /*#__PURE__*/React.createElement(Col, {
      md: "auto",
      className: "p-0"
    }, /*#__PURE__*/React.createElement("div", null, extractDate(data.created_at))), /*#__PURE__*/React.createElement(Col, {
      md: "auto"
    }, (pageAccess.canDeleteProjectNotes || data.user_id === user.id) && /*#__PURE__*/React.createElement(DeleteButton, {
      onClick: () => deleteComment(data.id, data.note)
    })), /*#__PURE__*/React.createElement(Col, {
      md: "auto"
    }, /*#__PURE__*/React.createElement("div", null, data.user_name)));
  };
  return /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md"
  }, /*#__PURE__*/React.createElement(Col, {
    md: 9
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: "8"
  }, /*#__PURE__*/React.createElement(InputGroup, null, /*#__PURE__*/React.createElement(ImmutableUnderReviewFormControl, {
    as: "textarea",
    rows: "3",
    placeholder: t('type_a_comment'),
    value: comment,
    onChange: e => setComment(e.target.value)
  }), /*#__PURE__*/React.createElement(Button, {
    isImmutableUnderReview: isImmutableUnderReview,
    variant: "primary",
    onClick: postComment,
    id: "button-addon2",
    disabled: false,
    className: "ms-1"
  }, t('save_a_new_comment'))))), report.report_notes && /*#__PURE__*/React.createElement("div", {
    id: "example-collapse-text"
  }, renderOneComment(report.report_notes[0])), /*#__PURE__*/React.createElement(Collapse, {
    in: open
  }, /*#__PURE__*/React.createElement("div", {
    id: "example-collapse-text"
  }, renderComments())), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: "8"
  }, /*#__PURE__*/React.createElement(Button, {
    isImmutableUnderReview: isImmutableUnderReview,
    onClick: () => setOpen(!open),
    "aria-controls": "example-collapse-text",
    "aria-expanded": open,
    className: "mt-2",
    variant: "primary"
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18 me-1"
  }, open ? 'arrow_upward' : 'arrow_downward'))))))));
};
export default ClaimProjectNotes;